const handleScheduleInterviewFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.message = action.payload.message;
};
const handleRescheduleInterviewFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.message = action.payload.message;
};
const handleCreateInstantInterviewFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.message = action.payload.message;
  state.interviewData= action.payload.data;
};
const handleUpdateInstantInterviewStatusFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.message = action.payload.message;
};
const handlefetchInterviewStatusFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.message = action.payload.message;
  state.interviewDetail = action.payload.data;
};
const handleMarkInterviewCompletedFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.message = action.payload.message;
};

const handleInterviewTimeSlotsFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.message = action.payload.message;
  state.interviewTimeSlots = action.payload.data;
};

const handleInterviewDateSlotsFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.message = action.payload.message;
  state.interviewDateSlots = action.payload.data;
}

const handleCancelInterviewFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.message = action.payload.message;
};

const handleManageInterviewStatusFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.message = action.payload.message;
};

const handleCancelInviteFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.message = action.payload.message;
};

const handleUnArchiveJobStageFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.message = action.payload.message;
};

export {
  handleScheduleInterviewFulfilled,
  handleCreateInstantInterviewFulfilled,
  handleUpdateInstantInterviewStatusFulfilled,
  handlefetchInterviewStatusFulfilled,
  handleMarkInterviewCompletedFulfilled,
  handleInterviewTimeSlotsFulfilled,
  handleInterviewDateSlotsFulfilled,
  handleCancelInterviewFulfilled,
  handleManageInterviewStatusFulfilled,
  handleCancelInviteFulfilled,
  handleRescheduleInterviewFulfilled,
  handleUnArchiveJobStageFulfilled
};
